/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useMemo, useState } from 'react'
import { UserPickActivity } from './UserPickActivity'
import { TotalTabWrap } from '@styles/base.style'
import { Tabs } from 'antd-mobile'
import { Models } from 'rmc-tabs/lib/Models'
import useRootStore from '@store/useRootStore'
import { useOnUnmount } from '@utils/reactExt'
import _ from 'lodash'
import { PostingCheerForTeam } from '@views/MyPage/UserActivity/PostingActivity/PostingCheerForTeam'

enum USER_ACTIVITY_TAB_KEY {
  USER_PICK = 'user-pick',
  SPORT_TALK = 'sport-talk',
}

interface PostingActivityProps {
  baseMonth?: string
}

export const PostingActivity: React.FC<PostingActivityProps> = observer((props: PostingActivityProps) => {
  const { userPickStore, userStore } = useRootStore()
  const [currentTabKey, setCurrentTabKey] = useState(USER_ACTIVITY_TAB_KEY.USER_PICK)
  const { myActivity } = userStore
  const { baseMonth } = props

  useOnUnmount(() => {
    userPickStore.resetUserPickMine()
  })

  const userActivityTabList = useMemo(() => {
    let userPickCount
    let cheerForTeamCount

    if (_.isNil(baseMonth)) {
      userPickCount = myActivity?.totalUserPickCount
      cheerForTeamCount = myActivity?.totalCheerForTeamCount
    } else {
      userPickCount = myActivity?.monthlyUserPickCount
      cheerForTeamCount = myActivity?.monthlyCheerForTeamCount
    }

    return [
      {
        title: (
          <span className="tab-item large-txt">
            <span className="txt">나도 승부사</span>
            <span className="num">{userPickCount}</span>
          </span>
        ),
        name: '나도 승부사',
        key: USER_ACTIVITY_TAB_KEY.USER_PICK,
      },
      {
        title: (
          <span className="tab-item large-txt">
            <span className="txt">스포츠톡</span>
            <span className="num">{cheerForTeamCount}</span>
          </span>
        ),
        name: '스포츠톡',
        key: USER_ACTIVITY_TAB_KEY.SPORT_TALK,
      },
    ]
  }, [myActivity, myActivity.monthlyCheerForTeamCount, myActivity.totalCheerForTeamCount])

  const onChange = (tab: Models.TabData) => {
    setCurrentTabKey(tab.key as USER_ACTIVITY_TAB_KEY)
  }

  let contents
  switch (currentTabKey) {
    case USER_ACTIVITY_TAB_KEY.USER_PICK:
      contents = <UserPickActivity baseMonth={baseMonth}/>
      break
    case USER_ACTIVITY_TAB_KEY.SPORT_TALK:
      contents = <PostingCheerForTeam baseMonth={baseMonth}/>
      break
  }

  return (
    <Fragment>
      <TotalTabWrap underline>
        <Tabs
          tabs={userActivityTabList}
          initialPage={0}
          page={currentTabKey}
          onChange={onChange}
        />
      </TotalTabWrap>
      {contents}
    </Fragment>
  )
})
